import React, { useContext, useEffect, useState } from "react";
import homeslider1 from "../assets/image/homeslider1.webp";
import biography from "../assets/image/bioqrafiyaimg.jpeg";
import logowhite from "../assets/image/logowhite.png";
import logodark from "../assets/image/logodark.png";
import { Link, NavLink, useLocation } from "react-router-dom";
import axios from "axios";
import slugify from "react-slugify";
import BreadCrumb from "../pages/BreadCrumb";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import required modules
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";

import slider1 from "../assets/image/slider1.jpg";
import slider2 from "../assets/image/parallax4.jpg";
import slider3 from "../assets/image/parallax1.jpg";
import { LanguageContext } from "../context/LanguageContext";
import translations from "../data/langData";
// import slider1 from "../assets/image/slider1.jpg" ;

const Header = () => {
  const [name,setName] = useState()
  const [lastName,setLastName] = useState()
  const { language, changeLanguage } = useContext(LanguageContext);
  const t = translations[language];
  const [jwt] = useState(localStorage.getItem("jwt") || "")
  const [slider,setSlider] = useState([])
  const [redirect,setRedirect] = useState()
  const handleLanguageChange = (event) => {
    const newLanguage = event.target.value;
    changeLanguage(newLanguage);
  };

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openMobile, setOpenMobile] = useState(false);
  const [openMobile1, setOpenMobile1] = useState(false);
  const [openMobile2, setOpenMobile2] = useState(false);
  const [kocinq, setKocinq] = useState([]);
  const [cat, setCat] = useState([]);
  const location = useLocation();
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add("mobile-menu-open");
    } else {
      document.body.classList.remove("mobile-menu-open");
    }

    return () => {
      document.body.classList.remove("mobile-menu-open");
    };
  }, [isMobileMenuOpen]);
  useEffect(() => {
    if (jwt) {
      axios.get("https://www.turanozbahceci.com/api/profile.php",{
        headers: {
          Authorization: `Bearer ${jwt}`,
          "Content-Type": "application/json",
        },
      })
      .then((res)=>{
        setName(res.data.user.firstName)
        setLastName(res.data.user.lastName)
        setRedirect(res.data.user.subscription);
      })
      .catch((err)=>{
        console.log(err);
      })
    }
    Promise.all([
      axios.get("https://www.turanozbahceci.com/api/sessiyalar.php"),
      axios.get("https://www.turanozbahceci.com/api/cat.php"),
      axios.get("https://turanozbahceci.com/api/slide.php")
    ]).then(([sessiyaRes, catRes,slideRes]) => {
      setKocinq(sessiyaRes.data);
      setCat(catRes.data);
      setSlider(slideRes.data)
    });
  }, []);

  // useEffect(() => {
  //   const handleStorageChange = () => {
  //     setName(localStorage.getItem("name") || "");
  //     setLastName(localStorage.getItem("lastName") || "");
  //   };

  //   window.addEventListener("storage", handleStorageChange);

  //   return () => {
  //     window.removeEventListener("storage", handleStorageChange);
  //   };
  // }, []);
  return (
    <>
      <div id="page">
        <div
          className="header-section header-transparent header-sticky-bg-dark header-light sticky-header section"
          style={{
            background: `${location.pathname == "/contact" ? "#000" : ""}`,
          }}
        >
          <div className="header-inner">
            <div className="container-fluid position-relative">
              <div className="row justify-content-between align-items-center">
                {/* Header Logo Start */}
                <div className="col-xl-2 col-auto">
                  <NavLink to="/" className="header-logo">
                    {/* <a href="index.html"> */}

                    <img
                      className="light-logo p-0"
                      src={logowhite}
                      alt="Learts Logo"
                    />
                    {/* </a> */}
                  </NavLink>
                </div>
                {/* Header Logo End */}
                {/* Header Main Menu Start */}
                <div className="col d-none d-xl-block position-static">
                  <nav className="site-main-menu menu-hover-1">
                    <ul >
                      <li className="has-children" >
                        <NavLink to="/biography" style={{
                      fontSize:`${language == "ru" ? "small" : ""}`
                    }}>
                          <span>{t.bio}</span>
                        </NavLink>
                      </li>
                      <li className="has-children">
                        <a href="#" style={{
                      fontSize:`${language == "ru" ? "small" : ""}`
                        }}>
                          <span className="menu-text">{t.isimkanlari}</span>
                        </a>
                        <span className="menu-toggle">
                          <i className="fas fa-angle-down" />
                        </span>
                        <ul className="sub-menu" style={{width:"auto"}}>
                          <li>
                            <li className="has-children">
                              <NavLink to="/">
                                <span className="menu-text">
                                  {t.karyeramerkezi}
                                </span>
                              </NavLink>
                              <span className="menu-toggle">
                                <i className="fas fa-angle-down" />
                              </span>
                              <ul className="sub-menu" style={{width:"auto"}} >
                                <li>
                                  <NavLink to="/resume">
                                    <span className="menu-text">
                                      {t.karyeramerkezi1}
                                    </span>
                                  </NavLink>
                                </li>
                                {/* <li>
                                  <a href="/">
                                    <span className="menu-text">
                                      {t.karyeramerkezi2}
                                    </span>
                                  </a>
                                </li> */}
                                <li>
                                  <a href="/" >
                                    <span className="menu-text">
                                      {t.karyeramerkezi3}
                                    </span>
                                  </a>
                                </li>
                              </ul>
                            </li>
                          </li>
                          <li>
                            <li className="has-children" >
                              <a href="/">
                                <span className="menu-text">
                                  {t.insanresurs}
                                </span>
                              </a>
                              <span className="menu-toggle">
                                <i className="fas fa-angle-down" />
                              </span>
                              <ul className="sub-menu " style={{width:"auto"}}>
                                <li>
                                  <NavLink to="/jobpostings">
                                    <span className="menu-text">
                                      {t.insanresurs1}
                                    </span>
                                  </NavLink>
                                </li>
                                <li>
                                  <a href="/">
                                    <span className="menu-text">
                                      {t.insanresurs2}
                                    </span>
                                  </a>
                                </li>
                              </ul>
                            </li>
                          </li>
                        </ul>
                      </li>
                      <li className="has-children">
                        <NavLink to="/investclub" style={{
                      fontSize:`${language == "ru" ? "small" : ""}`
                    }}>
                          <span>{t.investclub}</span>
                        </NavLink>
                      </li>
                      <li className="has-children">
                        <NavLink to="/projects" style={{
                      fontSize:`${language == "ru" ? "small" : ""}`
                    }}>
                          <span>{t.projects}</span>
                        </NavLink>
                        <span className="menu-toggle">
                          <i className="fas fa-angle-down" />
                        </span>
                      </li>
                      <li className="has-children">
                        <a href="#" style={{
                      fontSize:`${language == "ru" ? "small" : ""}`
                    }}>
                          <span className="menu-text">{t.subscribe}</span>
                        </a>
                        <span className="menu-toggle">
                          <i className="fas fa-angle-down" />
                        </span>
                        <span className="menu-toggle">
                          <i className="fas fa-angle-down" />
                        </span>
                        <ul className="sub-menu" style={{width:"auto"}}>
                          <li className="has-children">
                        <NavLink to="/company">
                          <span >{t.karyeramerkezi}</span>
                        </NavLink>
                      </li>
                          <li>
                            <NavLink to="/employee">
                              <span className="menu-text">{t.insanresurs}</span>
                            </NavLink>
                          </li>
                        </ul>
                      </li>
                      <li className="has-children">
                        <a href="#" style={{
                      fontSize:`${language == "ru" ? "small" : ""}`
                    }}>
                          <span className="menu-text">{t.coaching}</span>
                        </a>
                        <span className="menu-toggle">
                          <i className="fas fa-angle-down" />
                        </span>
                        <ul className="sub-menu " style={{width:"auto"}}>
                          <li>
                            <Link to="/coaching">
                              <span className="menu-text">{t.allcoaching}</span>
                            </Link>
                          </li>
                          <hr />
                          {kocinq.map((item) => {
                            return (
                              <li>
                                <NavLink
                                  to={`coachings/${slugify(
                                    `${item.id}-${item.name}`
                                  )}`}
                                >
                                  <span className="menu-text">
                                    {" "}
                                    {language == "az"
                                      ? item.name
                                      : language == "en"
                                      ? item.name_en
                                      : language == "ru"
                                      ? item.name_ru
                                      : language == "tr"
                                      ? item.name_tr
                                      : language == "de"
                                      ? item.name_de
                                      : language == "pl"
                                      ? item.name_pl
                                      : ""}
                                  </span>
                                </NavLink>
                              </li>
                            );
                          })}
                        </ul>
                      </li>
                      
                      <li className="has-children">
                        <a href="#" style={{
                      fontSize:`${language == "ru" ? "small" : ""}`
                    }}>
                          <span className="menu-text">{t.news}</span>
                        </a>
                        <span className="menu-toggle">
                          <i className="fas fa-angle-down" />
                        </span>
                        <span className="menu-toggle">
                          <i className="fas fa-angle-down" />
                        </span>
                        
                        <ul className="sub-menu">
                          
                          <li>
                            <NavLink to="/new">
                              <span className="menu-text">{t.allnews}</span>
                            </NavLink>
                          </li>
                          <hr />
                          {cat.map((item) => {
                            return (
                              <li>
                                <NavLink
                                  to={`/news/${slugify(
                                    `${item.id}-${item.name}`
                                  ).toLowerCase()}`}
                                >
                                  <span className="menu-text">
                                    {" "}
                                    {language == "az"
                                      ? item.name
                                      : language == "en"
                                      ? item.nameEn
                                      : language == "ru"
                                      ? item.nameRu
                                      : language == "tr"
                                      ? item.nameTr
                                      : language == "de"
                                      ? item.nameDe
                                      : language == "pl"
                                      ? item.namePl
                                      : ""}
                                  </span>
                                </NavLink>
                              </li>
                            );
                          })}
                        </ul>
                      </li>

                    </ul>
                  </nav>
                </div>
                {/* Header Main Menu End */}
                {/* Header Right Start */}
                <div className="col-xl-2 col-auto">
                  <div className="header-right">
                    <div className="inner1">
                      <select
                        name=""
                        id=""
                        className="mx-3 py-2"
                        value={language}
                        onChange={handleLanguageChange}
                      >
                        <option value="tr">TR</option>
                        <option value="az">AZ</option>
                        <option value="en">EN</option>
                        <option value="ru">RU</option>
                        {/* <option value="de">DE</option>
                        <option value="pl">PL</option> */}
                      </select>
                      <div
                        className="header-login  p-2"
                        style={{
                          border: "1px solid grey",
                          borderRadius: "15px",
                        }}
                      >
                        <NavLink to={`${redirect && redirect == "2" ? "/admin" : "/dashboard" ? "/signin" : ""}`}>
                          <i className="far fa-user-circle me-2" />
                          <span>{name && lastName ? `${name} ${lastName}` : t.signin}</span>
                        </NavLink>   
                        
                      </div>

                      
                      <div
                        className="header-mobile-menu-toggle d-xl-none ml-sm-2"
                        onClick={() =>
                          setIsMobileMenuOpen((prevState) => !prevState)
                        }
                      >
                        <button className="toggle">
                          <i className="icon-top" />
                          <i className="icon-middle" />
                          <i className="icon-bottom" />
                        </button>
                      </div>
                      {/* Header Mobile Menu Toggle End */}
                    </div>
                  </div>
                </div>
                {/* Header Right End */}
              </div>
            </div>
          </div>
        </div>

        <div className="homeSlider">
          {location.pathname == "/" ? (
            <>
              <Swiper
                spaceBetween={30}
                effect={"fade"}
                navigation={true}
                pagination={{
                  clickable: true,
                }}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                modules={[EffectFade, Navigation, Pagination, Autoplay]}
                className="mySwiper myHomeSlider"
              >
                {
                  slider.map((item)=>{
                    return                  <SwiperSlide>
                    <div className="imgSlider">
                      <img
                        src={item.img}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          position: "relative",
                        }}
                      />
                      <div className="outlineslider">
                        <div className="title" data-aos="fade-up">
                          <h2>  {language == "az"
                              ? item.name
                              : language == "en"
                              ? item.nameEn
                              : language == "ru"
                              ? item.nameRu
                              : language == "tr"
                              ? item.nameTr
                              : language == "de"
                              ? item.nameDe
                              : language == "pl"
                              ? item.namePl
                              : ""}</h2>
                          <h6 className="ms-1">{language == "az"
                              ? item.descrip
                              : language == "en"
                              ? item.descripEn
                              : language == "ru"
                              ? item.descripRu
                              : language == "tr"
                              ? item.descripTr
                              : language == "de"
                              ? item.descripDe
                              : language == "pl"
                              ? item.descripPl
                              : ""}</h6>
                          <NavLink to={item.href}>
                            <button className=" btn-primary mt-2 ms-1 hoverChange">
                            {language == "az"
                              ? item.button
                              : language == "en"
                              ? item.buttonEn
                              : language == "ru"
                              ? item.buttonRu
                              : language == "tr"
                              ? item.buttonTr
                              : language == "de"
                              ? item.buttonDe
                              : language == "pl"
                              ? item.buttonPl
                              : ""}
                            </button>
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  })
                }

              </Swiper>
            </>
          ) : (
            <BreadCrumb />
          )}

          <div className="outline"></div>
          <h1
            className={`${location.pathname !== "/" && "mt-5"}`}
            style={{ left: `${location.pathname === "/" ? "" : "20%"}` }}
          >
            {/* {pageTitle} */}
          </h1>
          {/* {pageTitle == "Üşenme,erteleme,vazgeçme" && <p>Turan Ozbahceci</p>} */}
        </div>
      </div>

      <div id="site-main-mobile-menu" className="site-main-mobile-menu">
        <div className="site-main-mobile-menu-inner">
          <div className="mobile-menu-header">
            <div className="mobile-menu-logo">
              <NavLink to="/" onClick={() => setIsMobileMenuOpen(false)}>
                <img src={logodark} alt="logo" className="img-fluid w-100" />
              </NavLink>
            </div>
            <div
              className="mobile-menu-close"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <button className="toggle">
                <i className="icon-top" />
                <i className="icon-bottom" />
              </button>
            </div>
          </div>
          <div className="mobile-menu-content">
            <nav className="site-mobile-menu">
              <ul>
                <li className="has-children">
                  <NavLink
                    to="/biography"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    <span className="menu-text">{t.bio}</span>
                  </NavLink>
                </li>
                <li className="has-children">
                  <a href="#">
                    <span className="menu-text">{t.isimkanlari}</span>
                  </a>
                  <span
                    className="menu-toggle"
                    onClick={() => setOpenMobile(!openMobile)}
                  >
                    <i
                      className={`fas fa-angle-${openMobile ? "up" : "down"}`}
                    />
                  </span>
                  <ul
                    className={`sub-menu ${openMobile ? "d-block" : "d-none"}`}
                  >
                    <li>
                      <NavLink to="/resume" onClick={() => setIsMobileMenuOpen(false)}>
                        <span className="menu-text">{t.karyeramerkezi1}</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/jobpostings" onClick={() => setIsMobileMenuOpen(false)}>
                        <span className="menu-text">{t.insanresurs1}</span>
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <NavLink
                    to="/investclub"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    <span className="menu-text">{t.investclub}</span>
                  </NavLink>
                </li>
                <li className="has-children">
                  <NavLink
                    to="/projects"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    <span className="menu-text">{t.projects}</span>
                  </NavLink>
                </li>
                <li className="has-children">
                  <a href="#">
                    <span className="menu-text">{t.coaching}</span>
                  </a>
                  <span
                    className="menu-toggle"
                    onClick={() => setOpenMobile1(!openMobile1)}
                  >
                    <i
                      className={`fas fa-angle-${openMobile1 ? "up" : "down"}`}
                    />
                  </span>
                  <ul
                    className={`sub-menu ${openMobile1 ? "d-block" : "d-none"}`}
                  >
                    {kocinq.map((item) => {
                      return (
                        <li>
                          <NavLink
                            to={`coachings/${slugify(
                              `${item.id}-${item.name}`
                            )}`}
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            <span className="menu-text">
                            {language == "az"
                                      ? item.name
                                      : language == "en"
                                      ? item.name_en
                                      : language == "ru"
                                      ? item.name_ru
                                      : language == "tr"
                                      ? item.name_tr
                                      : language == "de"
                                      ? item.name_de
                                      : language == "pl"
                                      ? item.name_pl
                                      : ""}
                            </span>
                          </NavLink>
                        </li>
                      );
                    })}
                  </ul>
                </li>
                <li className="has-children">
                  <NavLink
                    to="/new"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    <span className="menu-text">{t.news}</span>
                  </NavLink>
                </li>

                <li className="has-children">
                  <a href="#">
                    <span className="menu-text">{t.subscribe}</span>
                  </a>
                  <span
                    className="menu-toggle"
                    onClick={() => setOpenMobile2(!openMobile2)}
                  >
                    <i
                      className={`fas fa-angle-${openMobile2 ? "up" : "down"}`}
                    />
                  </span>
                  <ul
                    className={`sub-menu ${openMobile2 ? "d-block" : "d-none"}`}
                  >
                    <li>
                      <a href="#">
                        <span className="menu-text">{t.coaching}</span>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <span className="menu-text">{t.isimkanlari}</span>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <span className="menu-text">{t.subsemek}</span>
                      </a>
                    </li>
                  </ul>
                </li>


              </ul>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
